// extracted by mini-css-extract-plugin
export default {"wrapper":"Findings_wrapper__FBzWc"};